import { createFileRoute } from "@tanstack/react-router";
import AppCard from "@/components/AppCard.tsx";
import ParticipationsDataGrid from "@/components/participations/ParticipationsDataGrid.tsx";
import AssociatedParticipationsDataGrid from "@components/modules/participations/AssociatedParticipationsDataGrid.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";
import { PermissionGuard } from "@/auth/PermissionGuard.tsx";

export const Route = createFileRoute("/_dashboard/participations/")({
  beforeLoad: (args) => {
    const { context } = args;
    return { isAdmin: context.session!.user!.isAdmin };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();

  return (
    <>
      <PermissionGuard admin>
        <AppCard title={"Participations"} sx={{ position: "relative" }}>
          <ParticipationsDataGrid />
        </AppCard>
      </PermissionGuard>
      <PermissionGuard roles={[ROLE_USER]}>
        <AppCard title={"Vos modules"}>
          <AssociatedParticipationsDataGrid
            laboratoryUserUuid={context.session!.user!.uuid}
          />
        </AppCard>
      </PermissionGuard>
    </>
  );
}
